import { ReactNode } from 'react';

import { LibraryDownloadModal } from '../components/library-download-modal';
import { LibraryModalType } from '../enum/library-modal-type.enum';

export const ModalTypeComponentMap: Record<LibraryModalType, ReactNode> = {
  [LibraryModalType.DOWNLOAD]: <LibraryDownloadModal />,
};
